<form (ngSubmit)="onSubmit()" #filterForm="ngForm">

    <div class="filter-row" *ngFor="let choice of filterModel.choices">
        <bd-checkbox-squared [name]="'checkbox-' + choice.label" [(ngModel)]="choice.selected"
                             (ngModelChange)="onFilterCheckboxClicked()">
            <app-project-status-progress-bar [status]="projectStatusEnum[choice.label]">
            </app-project-status-progress-bar>
        </bd-checkbox-squared>

    </div>

    <div class="buttons-container">
        <button type="submit" class="pr-btn-filter primary" [disabled]="!filterModel.filterValueChanged">
            Filter übernehmen
        </button>
        <button type="button" (click)="onResetFilterBtnClicked()" class="pr-btn-filter"
                [disabled]="!filterModel.isResetBtnActive">
            Filter zurücksetzen
        </button>
    </div>


</form>
